import styled from 'styled-components'

export const Content = styled.div`
	/* Disable parent margin collapse */
	display: flow-root;
`
